import styled from 'styled-components';

const Button = styled.button`
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #0576ff;
    /* height: 40px;
    width: 110px; */
    padding: 7px 10px;
    color: #fff;
    font-weight: bold;
    font-size: 14px;
    user-select: none;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    outline: 0;

    :hover {
        opacity: .8;
    }
    
    :disabled {
        background-color: #8a8a8a;
        cursor: not-allowed;
        :hover {
          opacity: 1;
        }
    }
`;

export default Button;


// WEBPACK FOOTER //
// ./src/components/Button/Button.js